/* KALMO — storefront interactions. No dependencies. */
(() => {
  'use strict';
  const doc = document.documentElement;
  doc.classList.remove('no-js');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches) doc.classList.add('k-reduced');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  const money = (cents) => {
    const v = cents / 100;
    return new Intl.NumberFormat('cs-CZ', {
      style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CZK',
      minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2
    }).format(v);
  };

  let lastFocus = null;
  const focusables = (el) => $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', el)
    .filter((n) => n.offsetParent !== null || n === document.activeElement);
  const trap = (el, e) => {
    if (e.key !== 'Tab') return;
    const f = focusables(el); if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };
  const openLayer = (el) => {
    lastFocus = document.activeElement;
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('k-lock');
    const f = focusables(el); (f[0] || el).focus({ preventScroll: true });
  };
  const closeLayer = (el) => {
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('k-lock');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('keydown', (e) => {
    const open = $('.k-drawer[aria-hidden="false"], .k-menu[aria-hidden="false"]');
    if (!open) return;
    if (e.key === 'Escape') { closeLayer(open); syncToggles(); }
    else trap(open, e);
  });
  const syncToggles = () => {
    $$('[data-k-open="menu"]').forEach((b) => b.setAttribute('aria-expanded', $('#k-menu')?.getAttribute('aria-hidden') === 'false'));
  };

  const header = $('.k-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-k-open]');
    if (opener) {
      const id = opener.dataset.kOpen;
      if (id === 'cart') { e.preventDefault(); if (window.KalmoCart) window.KalmoCart.open(); else location.href = root + 'cart'; return; }
      const el = $('#k-' + id); if (!el) return;
      e.preventDefault(); openLayer(el); syncToggles(); return;
    }
    const closer = e.target.closest('[data-k-close]');
    if (closer) { const el = closer.closest('.k-menu, .k-drawer'); if (el) { closeLayer(el); syncToggles(); } return; }
    const inMenuLink = e.target.closest('.k-menu a[href*="#"]');
    if (inMenuLink) { const m = $('#k-menu'); if (m) { m.setAttribute('aria-hidden', 'true'); document.body.classList.remove('k-lock'); syncToggles(); } }
  });

  if ('IntersectionObserver' in window && !reduced.matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    $$('.k-reveal, .k-figure, .k-show').forEach((el) => io.observe(el));
  } else {
    $$('.k-reveal, .k-figure, .k-show').forEach((el) => el.classList.add('is-in'));
  }

  const show = $('.k-show__stage');
  if (show && !reduced.matches) {
    let ticking = false;
    const upd = () => {
      const r = show.getBoundingClientRect(); const vh = window.innerHeight;
      const p = Math.min(1, Math.max(0, (vh - r.top) / (vh * 0.9)));
      show.style.setProperty('--p', p.toFixed(3)); ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-k-stage-toggle]'); if (!b) return;
    const st = b.closest('.k-stage'); const paused = st.classList.toggle('is-paused');
    b.setAttribute('aria-pressed', String(paused));
    b.querySelector('[data-label]').textContent = paused ? b.dataset.play : b.dataset.pause;
    st.dispatchEvent(new CustomEvent('k:toggle', { detail: { paused } }));
  });

  $$('[data-k-spin]').forEach((spin) => {
    const frames = $$('img', spin); if (frames.length < 2) return;
    let i = 0, auto = !reduced.matches, timer = null, startX = 0, startI = 0, dragging = false;
    const show = (n) => { frames[i].classList.remove('is-on'); i = (n % frames.length + frames.length) % frames.length; frames[i].classList.add('is-on'); spin.setAttribute('aria-valuenow', String(i + 1)); };
    const play = () => { stop(); if (auto) timer = setInterval(() => show(i + 1), 90); };
    const stop = () => { clearInterval(timer); timer = null; };
    frames.forEach((f, n) => { if (n > 0) f.loading = 'lazy'; });
    spin.addEventListener('pointerdown', (e) => { dragging = true; startX = e.clientX; startI = i; stop(); spin.setPointerCapture(e.pointerId); });
    spin.addEventListener('pointermove', (e) => { if (!dragging) return; const dx = e.clientX - startX; show(startI - Math.round(dx / (spin.clientWidth / frames.length / 1.2))); });
    const end = () => { if (!dragging) return; dragging = false; auto = false; };
    spin.addEventListener('pointerup', end); spin.addEventListener('pointercancel', end);
    spin.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); auto = false; stop(); show(i - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); auto = false; stop(); show(i + 1); }
    });
    const st = spin.closest('.k-stage');
    st && st.addEventListener('k:toggle', (e) => { auto = !e.detail.paused; auto ? play() : stop(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => { en.isIntersecting ? play() : stop(); }).observe(spin);
    else play();
  });

  $$('[data-k-tabs]').forEach((wrap) => {
    const tabs = $$('[data-k-tab]', wrap); const imgs = $$('[data-k-tab-img]', wrap); const label = $('[data-k-tab-label]', wrap);
    const select = (t, focus) => {
      tabs.forEach((x) => x.setAttribute('aria-expanded', String(x === t)));
      const n = t.dataset.index; imgs.forEach((im) => im.classList.toggle('is-on', im.dataset.kTabImg === n));
      if (label) label.textContent = t.dataset.label || '';
      if (focus) t.focus();
    };
    tabs.forEach((t, n) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        const k = e.key; let j = null;
        if (k === 'ArrowDown' || k === 'ArrowRight') j = (n + 1) % tabs.length;
        if (k === 'ArrowUp' || k === 'ArrowLeft') j = (n - 1 + tabs.length) % tabs.length;
        if (k === 'Home') j = 0; if (k === 'End') j = tabs.length - 1;
        if (j !== null) { e.preventDefault(); select(tabs[j], true); }
      });
    });
  });

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-k-video-play]'); if (!b) return;
    const frame = b.closest('.k-video__frame, .k-slide'); const v = frame && $('video', frame); if (!v) return;
    frame.classList.add('is-playing'); v.controls = true; v.muted = false;
    const p = v.play(); if (p && p.catch) p.catch(() => { v.muted = true; v.play().catch(() => {}); });
  });
  window.K = { $, $$, reduced, root, openLayer, closeLayer, money };
})();